import React from 'react';

export const FlagFRIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600" // Standard 3:2 ratio
    {...props}
  >
    <rect width="900" height="600" fill="#FFFFFF" rx="2"/> {/* White field (center) */}
    <rect width="300" height="600" fill="#002395" /> {/* Blue stripe */}
    <rect x="600" width="300" height="600" fill="#ED2939" /> {/* Red stripe */}
  </svg>
);